//import packages from node modules
import React, { useRef, useEffect, useState, useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import renderHTML from 'react-render-html'
import PropTypes from 'prop-types'
import { change, touch, Field, submit,untouch } from 'redux-form'
import { useSelector } from 'react-redux'


//import utility functions
import {
  creditcardDateValidation,
  creditcardValidation,
  requiredFieldValidation,
  creditcardTypeValidation
} from '../form/validation'

import {
  cancelGetCreditCard,
  cancelgetUser
} from '../../../utilities/api/account'

import { renderCTA } from '../cart'

import {
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../utilities/function/common'

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse
} from '../../../utilities/function/apiResponse'

import {
  getDataFromURL
} from "../../../utilities/function/urlparams"

import {
  getAppConfigValue,
  getAttributes
} from "../../../utilities/function/configuration"

import { updateFinished } from '../../../app/action'

import ACCOUNT_API from '../../../utilities/api/account'
import globalCookies from '../../../utilities/function/cookies'

//import shared components
import SimpleCheckbox from '../form/checkbox/simple'
import Tabs from '../tabs'
import CCnumberFields from '../form/ccnumberfield'
import SolidButton from '../button/solidbutton'
import DateField from '../form/textfield/date'
import Goback from '../goback'
import Loading from '../loading'
import TextField from '../form/textfield'

//import assets
import redirectIcon from '../../../utilities/images/redirect.svg'
import paymentMethodsLogos from '../../../utilities/images/payment-methods.svg'


//define  shared variables
export const NEW_CREDIT_CARD = 'New Credit Card'
export const SAVED_CREDIT_CARD = 'Saved Credit Card'
export const PAYPAL = 'PayPal'
export const BPAY = 'BPAY'
export const EFT = 'EFT'

//sub component: Payment Notes
const PaymentNotes = () => {
  return (
    <div className={'of-payment-option-notes clearfix'}>
      Note: This payment method may take 1-4 business days to be processes.
      Your service will not be activated until payment has cleared.
      We recommend using Paypal or a Credit Card for immediate activation of your service/s
    </div>
  )
}

//sub component: Payment Table
const PaymentTable = (props) => {
  const {list, heading} = props
  const renderHeading = () => {
    return (
      <div className={'of-payment-table__row of-payment-table__row--heading'}>
        <div className={'of-payment-table__heading text-font-1-100'}>{heading}</div>
      </div>
    )
  }
  const renderList = () => {
    if (list && list.length > 0) {
      return list.map((item, index) => {
        const {label, value} = item
        return (
          <div key={index} className={'of-payment-table__row lines-border-1-100'}>
            <div className={'of-payment-table__label text-font-3-100'}>{label}</div>
            <div className={'of-payment-table__value text-font-1-100'}>{value}</div>
          </div>
        )
      })
    }
  }
  return (
    <div className={'of-payment-table lines-border-1-100'}>
      {renderHeading()}
      <div className={'of-payment-table__list lines-border-1-100'}>
        {renderList()}
      </div>
    </div>
  )
}

PaymentTable.propTypes = {
  list: PropTypes.array,
  heading: PropTypes.string
}

//main component
let PaymentOptions = (props) => {
  const [requestCC, setRequestCC] = useState({})
  const initCC = useRef(false)
  const {
    form,
    dispatch,
    getUser,
    store_cc,
    isPayInvoice,
    goBack = props.goBack ? props.goBack : true,
    withRef = props.withRef ? props.withRef : false,
    location,
    history
  } = props
  const {
    cartData,
    cartStatus,
    PaymentForm,
    finished,
    accountStatus
  } = useSelector(state => ({
    cartData: state.app.cartData,
    cartStatus: state.app.cartStatus,
    PaymentForm: state.form.PaymentForm,
    finished: state.app.finished,
    accountStatus: state.app.accountStatus
  }))

  const timeout = useRef(null)
  const [requestGetInvoice, setRequestGetInvoice] = useState({})
  const isFullyPaid = useCallback(() => {
    const {status, data} = getUser
    if (isPayInvoice) {
      if (requestGetInvoice.status === 'success' && requestGetInvoice.data && requestGetInvoice.data.attributes) {
        const {status} = requestGetInvoice.data.attributes
        if (status === 'Paid') {
          return true
        }
      }
    } else {
      if (status === 'success' && cartStatus === 'success' && data && cartData && PaymentForm) {
        const {attributes} = data
        const {credit} = attributes
        const {total_amount} = cartData
        if (parseFloat(credit) >= parseFloat(total_amount)) {
          return true
        }
        if(parseFloat(total_amount)===0){
          return true
        }
      }else{
        if(cartData && cartData.total_amount){
          const {total_amount} = cartData
          if(parseFloat(total_amount)===0){
            return true
          }
        }
      }
    }
    return false
  }, [getUser, cartStatus, cartData, PaymentForm, isPayInvoice, requestGetInvoice])
  const initInvoice = useCallback(()=>{
    const {invoice_id} = getDataFromURL(location.search)
    const access_token = globalCookies.get('access_token')
    if (isPayInvoice && invoice_id && access_token) {
      if (requestGetInvoice.status === undefined) {
        ACCOUNT_API.setAccessToken(access_token)
        ACCOUNT_API.getInvoice(invoice_id).then(successresponse => {
          const data = getDataFromSuccessResponse(successresponse)
          if(data && data.attributes && data.attributes.status==="Paid"){
            if(cancelgetUser){
              cancelgetUser()
            }
            if(cancelGetCreditCard){
              cancelGetCreditCard()
            }
            if(timeout && timeout.current){
              window.clearTimeout(timeout)
            }
          }else{
            setRequestGetInvoice({
              ...requestGetInvoice,
              status: 'success',
              data
            })
          }
        }, errorresponse => {
          const error = getErrorFromFailResponse(errorresponse)
          console.log(error)
          history.push(history.location.pathname)
        })
      }
    }
  },[isPayInvoice, history, location, requestGetInvoice])
  const initFormValues = useCallback(()=>{
    if (getUser && getUser.status === 'success' && PaymentForm) {
      if (requestCC && requestCC.status === undefined) {
        setRequestCC({
          ...requestCC,
          status: 'loading'
        })
        if(cancelGetCreditCard){
          cancelGetCreditCard()
        }
        ACCOUNT_API.getCreditCard().then(successresponse => {
          const data = getDataFromSuccessResponse(successresponse)
          const newFinished = {
            ...finished,
            savedCards: data
          }
          const {credit} = getAttributes(getUser.data)
          updateFinished(dispatch, newFinished)
          const getFirstStoredCCID = () => {
            if (data && data.length) {
              if (data[0] && data[0].attributes) {
                const {card_id} = data[0].attributes
                return card_id
              }
            }
            return undefined
          }
          const setDefaultPaymentMethod = () => {
            if (getFirstStoredCCID()) {
              dispatch(change(form, 'payment_option', SAVED_CREDIT_CARD))
              dispatch(change(form, 'cc_id', getFirstStoredCCID()))

            } else {
              dispatch(change(form, 'payment_option', NEW_CREDIT_CARD))
              dispatch(change(form, 'cc_id', undefined))
            }
          }
          setRequestCC({
            ...requestCC,
            status: 'success',
            data
          })
          if(timeout && timeout.current){
            window.clearTimeout(timeout)
          }
          if(credit && parseFloat(credit)>0){
            dispatch(change(form, 'applyCredit', true))
          }
          if(isFullyPaid()) {
            dispatch(change(form, 'payment_option', BPAY))

          }else{
            setDefaultPaymentMethod()
          }
          initCC.current = true
        }, errorresponse => {
          const error = getErrorFromFailResponse(errorresponse)
          dispatch(change(form, 'payment_option', NEW_CREDIT_CARD))
          setRequestCC({
            ...requestCC,
            status: 'error',
            error
          })
          initCC.current = true
        })
      }
    } else {
      if (!initCC.current) {
        if (getUser.status === undefined && PaymentForm) {
          if(isFullyPaid()){
            dispatch(change(form, 'payment_option', BPAY))
          }else{
            dispatch(change(form, 'payment_option', NEW_CREDIT_CARD))
            dispatch(change(form, 'cc_id', undefined))
          }
          initCC.current = true
        }
      }
    }
  },[getUser, requestCC, dispatch, form, finished, initCC, isFullyPaid, PaymentForm,timeout])
  const prevPaymentOption = useRef(null)
  const paymentFormOnChange = useCallback(()=>{
    if(PaymentForm && PaymentForm.values){
      const {payment_option} = PaymentForm.values
      if(payment_option !== prevPaymentOption.current){
        dispatch(change(form,'card_number',null))
        dispatch(untouch(form,'card_number'))
        dispatch(untouch(form,'card_type'))
        prevPaymentOption.current = payment_option
      }
    }
  },[prevPaymentOption,PaymentForm,dispatch,form])

  useEffect(()=>{
    initInvoice()
    initFormValues()
    paymentFormOnChange()
  },[paymentFormOnChange,initFormValues,initInvoice])

  const getTabList = () => {
    const {existing} = getDataFromURL(location.search)
    let list = [
      {
        label: (<div className={'of-checkout-payment-form-tab'}>
          <i className={'of-checkout-payment-form-tab__icon icon-of-pay-invoice'}/>
          <span className={'of-checkout-payment-form-tab__text'}>Credit Card</span>
        </div>),
        onClick: () => {
          dispatch(change(form, 'payment_option', NEW_CREDIT_CARD))
          dispatch(change(form, 'cc_id', undefined))
        }
      }, {
        label: <div className={'of-checkout-payment-form-tab'}>
          <i className={'of-checkout-payment-form-tab__icon icon-of-paypal'}/>
          <span className={'of-checkout-payment-form-tab__text'}>PayPal</span>
        </div>,
        onClick: () => {
          dispatch(change(form, 'payment_option', PAYPAL))
        }
      }, {
        label: <div className={'of-checkout-payment-form-tab'}>
          <i className={'of-checkout-payment-form-tab__icon icon-of-bpay'}/>
          <span className={'of-checkout-payment-form-tab__text'}>BPAY</span>
        </div>,
        onClick: () => {
          dispatch(change(form, 'payment_option', BPAY))
        }
      }, {
        label: <div className={'of-checkout-payment-form-tab'}>
          <i className={'of-checkout-payment-form-tab__icon icon-of-bank-transfer'}/>
          <span className={'of-checkout-payment-form-tab__text'}>Bank Transfer</span>
        </div>,
        onClick: () => {
          dispatch(change(form, 'payment_option', EFT))
        }
      }
    ]
    if(isPayInvoice){ //  Make changes here
      if (withRef){
        list = list.splice(0, 2) 
        
      } else if(!finished || (finished && !finished.cart_token)){
        list = list.filter((i,index)=>index!==1)
      } 
    }
    
    if (existing) {
      list.push({
        label: <div className={'of-checkout-payment-form-tab'}>
          <i className={'of-checkout-payment-form-tab__icon icon-of-credit'}/>
          <span className={'of-checkout-payment-form-tab__text'}>Credit</span>
        </div>,
        onClick: () => {

        }
      })
    }
    return list
  }
  const getTabInit = () => {
    dispatch(change(form, 'payment_option', NEW_CREDIT_CARD))
  }
  const renderCCFields = () => {
    if (PaymentForm && PaymentForm.values) {
      const {payment_option} = PaymentForm.values
      if (payment_option === NEW_CREDIT_CARD || payment_option === SAVED_CREDIT_CARD) {
        const cardnumberChangeCallback = (cardType, meta, initFlag) => {
          if (!initFlag.current) {
            initFlag.current = true
          } else {
            if (initFlag.current) {
              dispatch(touch(form, 'card_type'))
              dispatch(change(form, 'card_type', cardType ? cardType.toUpperCase() : null))
            }
          }
        }
        const renderNewCCFields = () => {
          const store_cc_callback = () => {
            if (PaymentForm.values) {
              dispatch(change(form, 'store_cc', !PaymentForm.values.store_cc))
            }
          }
          return (
            <>
              <div className={'of-checkout-form__row'}>
                <div className='of-checkout-form__column of-checkout-form__column--full'>
                    <div className='of-checkout-form__cardinput'>
                      <Field label={'Credit Card Number'} callback={cardnumberChangeCallback} name={'card_number'}
                            component={CCnumberFields} placeholder={'Credit Card Number'}
                            validate={[requiredFieldValidation, creditcardValidation]}/>
                      <img className="of-checkout-form__paymentmethods" src={paymentMethodsLogos} alt="Paymant Methods"/>
                    </div>
                  <Field label={'Card Type'} name={'card_type'} component={TextField} type={'hidden'}
                         validate={[creditcardTypeValidation]}/>
                </div>
                
              </div>
              <div className='of-checkout-form__row'>
                <div className='of-checkout-form__column of-checkout-form__column--full'>
                  <Field label={'Name On Card'} name={'card_holder_name'} component={TextField} placeholder={'Name On Card'}
                         validate={[requiredFieldValidation]}/>
                </div>
              </div> 
              <div className='of-checkout-form__row'>
                <div className='of-checkout-form__column'>
                  <Field label={'Card Expiry'} name={'card_date'} component={DateField} placeholder={'Card Expiry'}
                         validate={[requiredFieldValidation, creditcardDateValidation]}/>
                </div>
                <div className='of-checkout-form__column'>
                  <Field label={'Card CCV'} name={'card_cvv'} component={TextField} placeholder={'CCV'}
                         validate={[requiredFieldValidation]}/>
                </div>
              </div>
              <div className={'of-checkout-form__row'}>
                <div className={'of-checkout-form__column of-checkout-form__column--full'}>
                  {store_cc ? <Field name={'store_cc'} component={SimpleCheckbox} callback={store_cc_callback}
                                     label={`Store my credit card details on file`}/> : <></>}
                </div>
              </div>
            </>
          )
        }
        const renderHasStoredCCFields = () => {
          const {data} = requestCC
          const {cc_id} = PaymentForm.values
          const renderStored = () => {
            if (data && data.length) {
              return data.map((item, index) => {
                const {attributes} = item
                const {
                  card_id,
                  card_last_four,
                  card_type,
                  expiry_month,
                  expiry_year
                } = attributes
                const renderCCLogo = () => {
                  if (card_type) {
                    switch (card_type.toLowerCase()) {
                      case 'visa':
                        return (
                          <div className={'of-stored-cc-fields__item-logo icon-of-visa-outline'}/>
                        )
                      case 'mastercard':
                        return (
                          <div className={'of-stored-cc-fields__item-logo icon-of-mastercard-outline'}/>
                        )
                      case 'american express':
                        return (
                          <div className={'of-stored-cc-fields__item-logo icon-of-amex-outline'}/>
                        )
                      default:
                        return (<></>)
                    }
                  }
                  return (<></>)
                }
                const renderRadioButton = () => {
                  if (cc_id === card_id) {
                    return (
                      <div
                        className={`of-stored-cc-fields__item-radio stored-cc-fields__item-radio--selected primary-border-1-100`}>
                        <div className={'of-stored-cc-fields__item-radio-inner primary-background-1-100'}/>
                      </div>
                    )
                  }
                  return (
                    <div className={`of-stored-cc-fields__item-radio primary-border-1-100`}/>
                  )
                }
                const onClick = (e) => {
                  e.preventDefault()
                  dispatch(change(form, 'cc_id', card_id))
                  dispatch(change(form, 'payment_option', SAVED_CREDIT_CARD))
                }
                return (<div key={index} className={'of-stored-cc-fields__item'} onClick={onClick}>
                  {renderRadioButton()}
                  {renderCCLogo()}
                  <div className={'of-stored-cc-fields__item-number text-font-3-100'}>**** ****
                    **** {card_last_four}</div>
                  <div
                    className={'of-stored-cc-fields__item-expiry text-font-3-100'}>Expiry: {expiry_month}/{expiry_year}</div>
                </div>)
              })
            }
            return undefined
          }
          const hasData = () => {
            return data && data.length
          }
          const renderNew = () => {
            const renderRadioButton = () => {
              if (payment_option === NEW_CREDIT_CARD) {
                if(hasData()){
                  return (
                    <div
                      className={`of-stored-cc-fields__item-radio stored-cc-fields__item-radio--selected primary-border-1-100`}>
                      <div className={'of-stored-cc-fields__item-radio-inner primary-background-1-100'}/>
                    </div>
                  )
                }
                return (<></>)
              }
              return (
                <div className={`of-stored-cc-fields__item-radio primary-border-1-100`}/>
              )
            }
            return (
              <>
                <div className="of-stored-cc-fields__item of-stored-cc-fields__item--new" onClick={(e => {
                  e.preventDefault()
                  dispatch(change(form, 'payment_option', NEW_CREDIT_CARD))
                  dispatch(change(form, 'cc_id', undefined))
                })}>
                  {renderRadioButton()}
                  <div className={`of-stored-cc-fields__item-label text-font-3-100${!hasData()?' of-stored-cc-fields__item-label--no-margin':''}`}>Use New Credit Card</div>
                </div>
                {payment_option === NEW_CREDIT_CARD ? <div
                  className={'of-stored-cc-fields__new'}>{renderNewCCFields()}</div> : <></>}
              </>
            )
          }
          return (<div className={'of-stored-cc-fields'}>
            {renderStored()}
            <Field component={TextField} type={'hidden'} name={'cc_id'}/>
            {renderNew()}
          </div>)
        }
        const renderSection = () => {
          if (requestCC && requestCC.status === 'success' && requestCC.data) {
            return (renderHasStoredCCFields())
          }
          return (renderNewCCFields())
        }
        return (<div className={'of-checkout-payment-options__cc-fields'}>
          {renderSection()}
        </div>)
      }
    }
    return (<></>)
  }
  const renderCredit = () => {
    const {status, data} = getUser
    if (status === 'success' && cartStatus === 'success' && data && data.attributes && cartData && cartData.total_amount && PaymentForm && PaymentForm.values) {
      const {applyCredit} = PaymentForm.values
      const {credit} = data.attributes



      if (credit && parseFloat(credit)) {


        const {total_amount} = cartData
        const getAccountCredit = () => {
          if (isFullyPaid()) {
            return (`-$${parseFloat(total_amount).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}`)
          }
          return (`-$${parseFloat(credit).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}`)
        }
        const getTotalDue = () => {
          if (isFullyPaid()) {
            return '0.00'
          }
          if (applyCredit) {
            const total = parseFloat(total_amount) - parseFloat(credit)
            return total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
          }
          return parseFloat(total_amount).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
        }
        const applyCreditCallback = (value) => {
          dispatch(change(form, 'applyCredit', value))
        }
        const renderCreditDetails = () => {
          if(parseFloat(total_amount)>0){
            return (
                <div className={'of-checkout-credit-details'}>
                  <div className={'of-checkout-credit-details__item'}>
                    <div className={'of-checkout-credit-details__label text-font-3-100'}>Total</div>
                    <div className={'of-checkout-credit-details__value text-font-1-100'}>${parseFloat(total_amount).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</div>
                  </div>
                  {applyCredit ? <div className={'of-checkout-credit-details__item'}>
                    <div className={'of-checkout-credit-details__label text-font-3-100'}>Account Credit</div>
                    <div className={'of-checkout-credit-details__value text-font-1-100'}>{getAccountCredit()}</div>
                  </div> : <></>}
                  {getTotalDue()? <div className={'of-checkout-credit-details__item'}>
                    <div className={'of-checkout-credit-details__label text-font-3-100'}>Due Today</div>
                    <div className={'of-checkout-credit-details__value text-font-1-100'}>${getTotalDue()}</div>
                  </div> : ''}
                </div>
            )
          }
          return (<></>)
        }
        return (
          <div className={'of-checkout-credit shades-primary-background-1-100'}>
            <div className={'of-checkout-credit__row'}>
              <div className={'of-checkout-credit__column'}>
                <div className={'of-checkout-credit__column-wrapper'}>
                  <div className={`of-checkout-credit__heading text-font-1-100`}>Account Credit: ${parseFloat(credit).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</div>
                  <div
                    className={`of-checkout-credit__apply${isFullyPaid() ? ' of-checkout-credit__apply--hidden' : ''}`}>
                    <Field name={'applyCredit'} readOnly={isFullyPaid()} component={SimpleCheckbox}
                           placeholder={'Card Name'}
                           label={'Apply account credit to this order'}
                           value={applyCredit}
                           callback={applyCreditCallback}/>
                  </div>
                </div>
              </div>
              <div className={'of-checkout-credit__column'}>
                {renderCreditDetails()}
              </div>
            </div>
          </div>
        )
      }
    }
    return (<></>)
  }
  const buttonOnClick = () => {
    dispatch(submit(form))
  }
  const renderPaymentOptionsCTA = () => {
    const renderInvoiceCTA = () => {
      if (requestGetInvoice.status === 'success' && requestGetInvoice.data && requestGetInvoice.data.attributes) {
        const {invoice_items, total, total_discount} = requestGetInvoice.data.attributes
        if (invoice_items && invoice_items.length > 0) {
          const renderTotal = () => {
            const products_total_amount = parseFloat(total) + parseFloat(total_discount)
            if (total_discount && parseFloat(total_discount) === 0) {
              return (<div className={'of-cart-main-cta__total'}>
                <div className={'of-cart-main-cta__total-after text-font-1-100'}>${total}</div>
              </div>)
            }
            return (<div className={'of-cart-main-cta__total of-cart-main-cta__total'}>
              <div
                className={'of-cart-main-cta__total-before text-font-3-100'}>${products_total_amount.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</div>
              <div className={'of-cart-main-cta__total-after status-font-3-100'}>${total}</div>
            </div>)
          }
          return (
            <div className={'of-cart-main-cta clearfix'}>
              <div className={'of-cart-main-cta__total-wrapper'}>
                <div className={'of-cart-main-cta__label text-font-3-100'}>Total Amount</div>
                {renderTotal()}
              </div>
              <SolidButton isSecondary={true} className={'of-cart-main-cta__button text-font-1-100'}
                           onClick={buttonOnClick}>
                <i className={'of-cart-main-cta__button-icon icon-of-lock'}/>Pay Invoice</SolidButton>
            </div>
          )
        }
      }
      return (<></>)
    }
    const getUseCredit = () =>{
      return !!(PaymentForm && PaymentForm.values && PaymentForm.values.applyCredit)
    }
    const useCredit = getUseCredit()
    if (isPayInvoice) {
      return (renderInvoiceCTA(cartData, 'Pay Invoice', buttonOnClick))
    }
    return (renderCTA(cartData, 'Complete Order', buttonOnClick,null,null,getUser,useCredit))
  }
  const renderPaymentInfo = () => {
    if (!isFullyPaid() && PaymentForm && PaymentForm.values) {
      const {payment_option} = PaymentForm.values
      const renderPaypal = () => {
        return (
          <div className={'of-payment-options-paypal shades-1-background-1-100'}>
            <div className={'of-payment-options-paypal__wrapper'}>
              <img className={'of-payment-options-paypal__icon'} src={redirectIcon} alt={'redirect'}/>
              <div className={'of-payment-options-paypal__description'}>
                After clicking <strong>{isPayInvoice?'Pay Invoice':'Complete Order'}</strong> you will redirected to the PayPal website to complete
                your order securely.
              </div>
            </div>
          </div>
        )
      }
      switch (payment_option) {
        case PAYPAL:
          return (
            renderPaypal()
          )
        case BPAY:
          return (
            <>
              <PaymentTable
                heading={BPAY}
                list={[{
                  label: 'Biller Code',
                  value: getAppConfigValue('bpay_billers_code')
                }, {
                  label: 'Reference No.',
                  value: 'Your reference number will be emailed to you upon clicking checkout.'
                }]}
              />
              <PaymentNotes/>
            </>
          )
        case EFT:
          return (
            <>
              <PaymentTable
                heading={'Bank Transfer Instructions'}
                list={[{
                  label: 'Account Name',
                  value: getAppConfigValue('eft_account_name')
                }, {
                  label: 'BSB',
                  value: getAppConfigValue('eft_account_bsb')
                }, {
                  label: 'Account Number',
                  value: getAppConfigValue('eft_account_number')
                }, {
                  label: 'Bank',
                  value: getAppConfigValue('eft_bank')?renderHTML(getAppConfigValue('eft_bank')):renderHTML('Bank of Melbourne,Level 8,<br/>530 Collins Street Melbourne VIC 3000')
                }, {
                  label: 'Reference No.',
                  value: 'Your reference number will be emailed to you upon clicking checkout.'
                }]}
              />
              <PaymentNotes/>
            </>
          )
        default:
          return (<></>)
      }
    }
    return (<></>)
  }
  const renderLoading = () => {
    if (requestGetInvoice.status === 'loading' || requestCC.status === 'loading' || getUser.status === 'loading') {
      return (<Loading wrapper={true} className={'of-checkout-payment-options__loading'}/>)
    }
    return (<></>)
  }
  const renderNothingToPay = () => {
    if(cartData && cartData.total_amount){
      const {total_amount} = cartData
      if(parseFloat(total_amount)===0){
        return (
            <div className={'of-checkout-nothing-to-pay lines-border-1-100'}>
              <div className={'of-checkout-nothing-to-pay__text text-font-1-100'}>Good news, {`there's`} nothing to pay today!</div>
            </div>
        )
      }
    }
    return (<></>)
  }

  //existing
  if (form && dispatch && getUser && Object.keys(getUser).length > 0) {

    return (
      <div className={'of-checkout-payment-options'}>
        {!isFullyPaid()?<div className={'of-checkout-payment-options__heading text-font-1-100'}>Payment Options</div>:""}
        {renderCredit()}
        {!isFullyPaid() ? <Tabs className={'of-checkout-payment-options__tabs'} list={getTabList()}
                                init={getTabInit}/> : <></>}
        <Field name='payment_option' component={TextField} type='hidden'/>
        {!isFullyPaid() ? renderCCFields() : <></>}
        {requestCC.status === 'success' && accountStatus !=="loading" && getUser.status!=="loading"? renderPaymentOptionsCTA() : <></>}
        {renderNothingToPay()}
        {renderPaymentInfo()}
        {renderLoading()}
      </div>
    )
  }
  
  //new customer
  if (form && dispatch) {
    return (
      <div className={'of-checkout-payment-options'}>
        {!isFullyPaid()?<div className={'of-checkout-payment-options__heading text-font-1-100'}>Payment Options</div>:""}
        {!isFullyPaid() ? <Tabs className={'of-checkout-payment-options__tabs'} list={getTabList()}
                                init={getTabInit}/> : <></>}
        <Field name='payment_option' component={TextField} type='hidden'/>
        {!isFullyPaid() ? renderCCFields() : <></>}
        {renderNothingToPay()}
        {renderCTA(cartData, 'Complete Order', buttonOnClick)}
        {renderPaymentInfo()}
        {goBack ? <Goback className={'of-checkout-payment-options__payment-goback'} url={'/?a=checkout&step=account&select=register'}>Go back</Goback>:""}
        {renderLoading()}
      </div>
    )
  }

  return (<></>)
}

PaymentOptions.propTypes = {
  getUser: PropTypes.any,
  location: PropTypes.any,
  history: PropTypes.any,
  form: PropTypes.any,
  dispatch: PropTypes.any,
  store_cc: PropTypes.bool,
  isPayInvoice: PropTypes.bool,
  withRef: PropTypes.bool,
  goBack: PropTypes.bool
}

PaymentOptions = withRouter(PaymentOptions)

export default PaymentOptions